import useHostGlobals from 'appHost/Globals';
import { HomeEventsSource } from 'constants/profile';
import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { useRiskManagement } from 'hooks/useRiskManagement';
import { useSendTracking } from 'hooks/useSendTracking';
import { TruckerSummaryProps } from 'open-search/types';
import { getAccountTextToCopyToClipboard } from 'utils/getAccountTextToCopyToClipboard';
import { useUserHasChat } from 'hooks/useUserHasChat';
import { useGlobals } from 'hooks/useGlobals';
import { TextsSearchTrucker } from '../types';
import { useClearOpenSearch } from '../useClearOpenSearch';

export function useTruckerSummary() {
  const {
    isProfileVisible,
    openSearchWidth,
    searchTruckerData,
    setIsProfileVisible,
    setValueInputSearch,
    setIsTextFieldFocus,
    setIsCardVisible,
  } = useOpenSearchContext();

  const global = useHostGlobals();

  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();
  const { navigateToRiskManagement, riskManagamentButtonIsVisible } = useRiskManagement();
  const [handleCopy] = useCopyToClipboard('Dados de pagamento', 'copiados com sucesso');
  const { hasChatFeature } = useUserHasChat();
  const { isShowNewHorizontal } = useGlobals();
  const { clearOpenSearch } = useClearOpenSearch();

  const hasAccount = !!(
    searchTruckerData?.trucker?.bank &&
    searchTruckerData.trucker.bank.account?.number &&
    searchTruckerData.trucker.bank.name &&
    searchTruckerData.trucker.bank.number &&
    searchTruckerData.trucker.bank.account?.branchNumber
  );

  const hasChatButton = hasChatFeature && searchTruckerData?.trucker?.planType !== 'deposit';

  const getAccountType = () => {
    if (searchTruckerData?.trucker?.bank?.pix?.length > 0) return 'Pix';
    return 'Ted';
  };

  const truckerMainDestination = searchTruckerData?.trucker?.mainDestination?.city
    ? searchTruckerData.trucker.mainDestination.city
    : textConstants.notAvailaible;

  const truckerRegion = searchTruckerData?.trucker?.phones?.map((code) => code.ddd);

  const handleCopyToClipboard = () => {
    const accountText = getAccountTextToCopyToClipboard(
      searchTruckerData?.trucker?.bank,
      searchTruckerData?.trucker?.name,
      searchTruckerData?.trucker?.bank?.account?.document
    );
    handleCopy(accountText);

    sendAmplitude('trucker_profile_bankinfo_copied', {
      type: getAccountType(),
      freightCode: textConstants.notAvailaible,
      truckerId: searchTruckerData?.trucker.id,
      source: 'home',
    });
    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_bankinfo_copied',
        data: {
          type: getAccountType(),
          freightId: textConstants.notAvailaible,
          truckerId: `hashed|${searchTruckerData?.trucker.id}`,
          source: 'home',
        },
      },
      'open_search'
    );
  };

  const propsTruckerSummary: TruckerSummaryProps = {
    searchedTrucker: searchTruckerData,
    hasAccount,
    hasChatButton,
    openSearchWidth,
    copyButtonProps: {
      states: { textContent: TextsSearchTrucker.textButtonCopy },
      events: {
        onClick: () => handleCopyToClipboard(),
      },
    },
    riskManagement: {
      buttonRiskManagement: {
        states: { textContent: TextsSearchTrucker.textButtonRiskManagement, isVisible: riskManagamentButtonIsVisible },
        events: {
          onClick: () => {
            sendAmplitude('trucker_profile_safety_check', {
              freightCode: textConstants.notAvailaible,
              source: 'home',
              truckerId: searchTruckerData?.trucker.id,
              isVerified: searchTruckerData?.isVerified,
            });

            sendTrackingJaiminho(
              {
                nameEvent: 'trucker_profile_safety_check',
                data: {
                  source: 'home',
                  truckerId: `hashed|${searchTruckerData?.trucker.id}`,
                  isVerified: searchTruckerData?.isVerified,
                  freightId: textConstants.notAvailaible,
                },
              },
              'open_search'
            );

            global?.dispatchToGlobal?.({ type: 'set_trucker_profile', payload: {} });
            if (isShowNewHorizontal) {
              clearOpenSearch();
            }

            navigateToRiskManagement(searchTruckerData?.trucker.id);
          },
        },
      },
    },
    openTruckerProfileButtonProps: {
      states: {
        textContent: hasChatButton
          ? TextsSearchTrucker.textButtonOpenProfileMobileWithChat
          : TextsSearchTrucker.textButtonOpenProfile,
        textContentMobile: hasChatButton
          ? TextsSearchTrucker.textButtonOpenProfileMobileWithChat
          : TextsSearchTrucker.textButtonOpenProfileMobile,
      },
      isOpen: isProfileVisible,
      events: {
        onClick: () => {
          setValueInputSearch('');
          setIsTextFieldFocus(false);
          setIsProfileVisible(true);
          setIsCardVisible(false);
          sendAmplitude('trucker_listing_profile_visited', {
            freightCode: textConstants.notAvailaible,
            source: HomeEventsSource,
            truckerId: searchTruckerData?.trucker.id,
            tag: textConstants.notAvailaible,
            codeRegion: truckerRegion,
            destiny: truckerMainDestination,
            isVerified: searchTruckerData?.isVerified,
          });

          sendTrackingJaiminho(
            {
              nameEvent: 'trucker_listing_profile_visited',
              data: {
                source: HomeEventsSource,
                truckerId: `hashed|${searchTruckerData?.trucker.id}`,
                tag: textConstants.notAvailaible,
                codeRegion: truckerRegion,
                destiny: truckerMainDestination,
                freightCode: textConstants.notAvailaible,
                isVerified: searchTruckerData?.isVerified,
              },
            },
            'open_search'
          );
        },
      },
    },
  };
  return { propsTruckerSummary };
}
